export default __webpack_public_path__ + "static/media/audio.4cb88c17.svg";